class InquiryPopup extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.inquiry-popup__trigger');
    this.overlay = this.querySelector('.inquiry-popup__overlay');
    this.dialog = this.querySelector('.inquiry-popup__dialog');
    this.closeButton = this.querySelector('.inquiry-popup__close');

    if (!this.trigger || !this.dialog) return;

    this.trigger.addEventListener('click', this.open.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));
    this.overlay.addEventListener('click', this.close.bind(this));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    if (this.querySelector('.form-status')) this.open();
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  open() {
    this.setAttribute('open', '');
    this.trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
    if (typeof trapFocus === 'function') trapFocus(this.dialog);
  }

  close() {
    this.removeAttribute('open');
    this.trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.trigger);
  }
}

customElements.define('inquiry-popup', InquiryPopup);
